import { useKomboIntegrationFindOneQuery } from 'generated/graphql';
import {
  InlineNotification,
  NotificationType,
} from '@spotted-zebra-uk/ui-components';
import styles from './KomboIntegrationWarningBanner.module.scss';

type KomboIntegrationWarningBannerProps = {
  companyId: number;
  atsIdentifier?: string | null;
};

export function KomboIntegrationWarningBanner({
  companyId,
  atsIdentifier,
}: KomboIntegrationWarningBannerProps) {
  const { data } = useKomboIntegrationFindOneQuery({
    variables: { companyId },
  });
  const integration = data?.komboIntegrationsFindOne;

  if (!integration) {
    return null;
  }

  const atsName = atsIdentifier || integration.tool || 'an ATS';

  return (
    <InlineNotification
      className={styles.banner}
      notificationType={NotificationType.WARNING}
      title="ATS integration active"
    >
      This company is integrated with {atsName} via Kombo. Changing settings or
      configuration here can break the integration. Check in the #integrations
      Slack channel before making any changes.
    </InlineNotification>
  );
}
